import UpdatePassword from '../../Customer/UpdatePassword'

function SchedulerOnboard () {
  return <UpdatePassword />
}

export default SchedulerOnboard
